const ResizableForm = {
    data() {
        return {
            minWidth: null,
            width: null,
        }
    },
    computed: {
        /**
         * Uniquge id for the width in localstorage
         * @return {string}
         */
        localStorageWidthId() {
            return `${this.bundle}-${this.definition}-width`;
        }
    },
    methods: {
        /**
         * Set the current minWidth
         * @param minWidth
         */
        setMinWidth(minWidth) {
            this.minWidth = minWidth;
        },
        /**
         * Update width
         *
         * Update the current width for this bundle and definition
         * @param width
         */
        updateWidth(width) {
            this.width = width;
            // We keep the current width in the local storage so when the user comes back tot this form we will use the same width
            localStorage.setItem(this.localStorageWidthId, this.width);
        }
    },
    created() {
        // Check if we have a width for this form and definition in storage
        const widthInStorage = localStorage.getItem(this.localStorageWidthId);

        if (widthInStorage) {
            this.width = widthInStorage;
        }
    }
}

export default ResizableForm;